import { render, staticRenderFns } from "./MenuGenerator.vue?vue&type=template&id=4272a5cd"
import script from "./MenuGenerator.vue?vue&type=script&lang=js"
export * from "./MenuGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports